module.exports = __webpack_public_path__ + "img/icon-timer.dd18743f.svg";